import { Controller } from 'stimulus';
import moment from 'moment';

export default class extends Controller {

  connect() {
    this.hidePastEvents();
  }
  hidePastEvents() {
    let now = moment().valueOf();
    let eventDateString = this.element.dataset.datetime;
    let eventMoment = moment(eventDateString, 'YYYY-MM-DD HH:mm:ss Z');
    let eventDateTime = eventMoment.valueOf();
    if (eventDateTime < now) {
      this.element.remove();
    }
    this.dispatchCompletedEvent();
  }
  dispatchCompletedEvent() {
    const event = new CustomEvent('eventCardProcessed', { bubbles: true });
    this.element.dispatchEvent(event);
  }

}
